// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementProductRecommenderNamesResult = objectOf({
  recommenders: arrayOf(
    objectOf({
      name: string,
      fields: arrayOf(
        objectOf({
          name: string,
          type: string,
        })
      ),
    })
  ),
});
